import React from 'react';
import { Sun, Settings, Bell, X } from 'lucide-react';

export default function WelcomeModal({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50 overflow-y-auto">
      <div className="bg-white rounded-2xl p-6 md:p-8 max-w-2xl w-full shadow-2xl relative animate-fadeIn my-8 max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>

        <div className="text-center mb-6">
          <Sun className="w-16 h-16 text-yellow-400 mx-auto mb-4" />
          <h2 className="text-3xl font-bold text-gray-800 mb-2">
            Welcome to 10/10! 🏖️
          </h2>
          <p className="text-gray-600">
            Let's set up your perfect beach day alerts
          </p>
        </div>

        {/* Default Preferences Card */}
        <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl p-6 mb-6">
          <h3 className="font-bold text-gray-800 mb-3">
            📊 What makes a 10/10 beach day? (Our defaults)
          </h3>
          <div className="grid grid-cols-2 gap-3 text-sm text-gray-700">
            <div>🌡️ Temperature: 75-85°F</div>
            <div>💨 Wind: Under 10 mph</div>
            <div>☁️ Cloud cover: Under 30%</div>
            <div>🌧️ Rain chance: Under 10%</div>
            <div>🌊 Waves: Calm</div>
            <div>💧 Water temp: 70°F+</div>
          </div>
        </div>

        {/* Alert Settings Card */}
        <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-xl p-6 mb-6">
          <h3 className="font-bold text-gray-800 mb-3">
            🔔 When will you get alerted?
          </h3>
          <div className="space-y-2 text-sm text-gray-700">
            <div>✓ When beach score is <strong>7+ out of 10</strong></div>
            <div>✓ Alert sent at <strong>8am local time</strong></div>
            <div>✓ Via <strong>email</strong> (SMS with Premium)</div>
            <div>✓ Checks <strong>tomorrow's forecast</strong> (1-3 days with Premium)</div>
          </div>
        </div>

        {/* Customize CTA */}
        <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-6">
          <div className="flex items-start gap-4">
            <Settings className="w-8 h-8 text-cyan-500 flex-shrink-0" />
            <div>
              <h3 className="font-bold text-gray-800 mb-2">
                Customize Everything!
              </h3>
              <p className="text-sm text-gray-600 mb-3">
                Don't like the defaults? No problem! Head to <strong>Settings</strong> to adjust:
              </p>
              <ul className="text-sm text-gray-600 space-y-1 ml-4">
                <li>• Your ideal temperature range</li>
                <li>• Wind, rain, and cloud preferences</li>
                <li>• <strong>Alert threshold</strong> (5-10, default is 7)</li>
                <li>• Time of day (morning/afternoon) with Premium</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Get Started Button */}
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-4 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-xl font-bold text-lg hover:from-cyan-600 hover:to-blue-600 transition-all shadow-lg"
          >
            Got it! Let's Go 🌊
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center mt-4">
          You can always change these settings later
        </p>
      </div>
    </div>
  );
}
